function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.5 0.52594C0.675 0.52594 0 1.20094 0 2.02594C0 2.85094 0.675 3.52594 1.5 3.52594C2.325 3.52594 3 2.85094 3 2.02594C3 1.20094 2.325 0.52594 1.5 0.52594ZM10.5 0.52594C9.675 0.52594 9 1.20094 9 2.02594C9 2.85094 9.675 3.52594 10.5 3.52594C11.325 3.52594 12 2.85094 12 2.02594C12 1.20094 11.325 0.52594 10.5 0.52594ZM4.5 2.02594C4.5 1.20094 5.175 0.52594 6 0.52594C6.825 0.52594 7.5 1.20094 7.5 2.02594C7.5 2.85094 6.825 3.52594 6 3.52594C5.175 3.52594 4.5 2.85094 4.5 2.02594Z",
  fill: "#A0A0A0"
});

function SvgEllipsesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 4,
    viewBox: "0 0 12 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsesIcon);
export default __webpack_public_path__ + "static/media/EllipsesIcon.6e705075.svg";
export { ForwardRef as ReactComponent };